import React from 'react';
import { Button } from './Button';
import { CountdownTimer } from './CountdownTimer';
import { ShieldCheck, Lock, CreditCard, Zap } from 'lucide-react';
export function FinalPurchaseSection() {
  return <section className="py-12 md:py-16 px-4 bg-brand-dark border-t border-white/5" data-id="element-59">
      <div className="max-w-4xl mx-auto" data-id="element-60">
        <div className="text-center mb-8" data-id="element-61">
          <div className="inline-block bg-brand-accent/20 text-brand-accent font-bold px-4 py-1.5 rounded-full mb-4 border border-brand-accent/30 animate-pulse text-sm" data-id="element-62">
            ⏰ EL PRECIO CIERRA EN
          </div>
          <div className="mb-8" data-id="element-63">
            <CountdownTimer data-id="element-64" />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto flex-col-reverse md:flex-row" data-id="element-65">
          {/* Premium Kit (Highlighted - First on mobile if we reverse, but let's just put it first in DOM) */}
          <div className="bg-brand-card rounded-xl border-2 border-brand-accent p-5 md:p-6 flex flex-col relative shadow-[0_0_20px_rgba(34,197,94,0.15)] order-1 md:order-1" data-id="element-66">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-brand-accent text-white font-black px-4 py-1 rounded-full text-xs tracking-wider shadow-sm whitespace-nowrap" data-id="element-67">
              MÁS ELEGIDO ⭐
            </div>

            <div className="mb-4 mt-2" data-id="element-68">
              <h3 className="text-xl font-black text-white mb-1 flex items-center" data-id="element-69">
                <span className="text-2xl mr-2" data-id="element-70">🏆</span> KIT COMPLETO +
                ECONOMÍA AGRO AVANZADA ⭐
              </h3>
              <p className="text-brand-accent font-bold text-sm" data-id="element-71">
                6 Tomos + 4 Bonos + Upsell
              </p>
            </div>

            <div className="mb-6 flex-grow flex items-end" data-id="element-72">
              <div className="flex items-end justify-start w-full" data-id="element-73">
                <span className="text-lg text-gray-600 line-through font-medium mr-2" data-id="element-74">
                  $63.000
                </span>
                <span className="text-3xl md:text-4xl font-black text-brand-accent neon-glow" data-id="element-75">
                  $29.990{' '}
                  <span className="text-lg text-gray-500 font-medium" data-id="element-76">ARS</span>
                </span>
              </div>
            </div>

            <Button href="https://checkout.kitonline.shop/cart/47923612287214:1" className="py-3 md:py-4 text-base md:text-lg" pulse={true} data-id="element-77">
              → QUIERO EL KIT COMPLETO
            </Button>
          </div>

          {/* Basic Kit */}
          <div className="bg-brand-card rounded-xl border border-white/10 p-5 md:p-6 flex flex-col relative order-2 md:order-2" data-id="element-78">
            <div className="mb-4" data-id="element-79">
              <h3 className="text-xl font-black text-white mb-1 flex items-center" data-id="element-80">
                <span className="text-2xl mr-2" data-id="element-81">📘</span> KIT ECONOMÍA
                AGROPECUARIA LISTA
              </h3>
              <p className="text-brand-accent font-bold text-sm" data-id="element-82">
                6 Tomos + 4 Bonos
              </p>
            </div>

            <div className="mb-6 flex-grow flex items-end" data-id="element-83">
              <div className="flex items-end justify-start w-full" data-id="element-84">
                <span className="text-lg text-gray-600 line-through font-medium mr-2" data-id="element-85">
                  $45.000
                </span>
                <span className="text-3xl md:text-4xl font-black text-white" data-id="element-86">
                  $24.990{' '}
                  <span className="text-lg text-gray-500 font-medium" data-id="element-87">ARS</span>
                </span>
              </div>
            </div>

            <Button href="https://checkout.kitonline.shop/cart/47923609698542:1" className="py-3 text-sm md:text-base bg-gray-800 hover:bg-gray-700 shadow-none" pulse={false} data-id="element-88">
              → QUIERO MI KIT AHORA
            </Button>
          </div>
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap justify-center gap-4 mt-10 text-xs md:text-sm text-gray-500 font-medium" data-id="element-89">
          <div className="flex items-center" data-id="element-90">
            <Lock className="w-4 h-4 mr-1.5 text-brand-accent" data-id="element-91" />
            <span data-id="element-92">Pago 100% seguro</span>
          </div>
          <div className="flex items-center" data-id="element-93">
            <Zap className="w-4 h-4 mr-1.5 text-brand-accent" data-id="element-94" />
            <span data-id="element-95">Acceso en 5 minutos</span>
          </div>
          <div className="flex items-center" data-id="element-96">
            <ShieldCheck className="w-4 h-4 mr-1.5 text-brand-accent" data-id="element-97" />
            <span data-id="element-98">Garantía 7 días</span>
          </div>
          <div className="flex items-center" data-id="element-99">
            <CreditCard className="w-4 h-4 mr-1.5 text-brand-accent" data-id="element-100" />
            <span data-id="element-101">Mercado Pago | Tarjeta | Transferencia</span>
          </div>
        </div>
      </div>
    </section>;
}